import globalMU from "globalMU"

export type CMC7 = string

export function decodificar(cmc7: CMC7) : ({
    numeroBanco?: string,
    numeroAgencia?: string,
    numeroDocumento?: string,
    numeroConta?: string
}) {
    const parte1 = cmc7?.match?.(/<(.*)</)
    const parte2 = cmc7?.match?.(/((?:.*?<){2}(.*))(?:.*>){2}/)
    const parte3 = cmc7?.match?.(/(?:.*?>){1}(.*)(?:.*>){1}/)

    return {
        numeroBanco: (parte1?.length ?? 0) > 1 ? globalMU.replaceAll(parte1[1].substring(0, 3), "_", "") : null,
        numeroAgencia: (parte1?.length ?? 0) > 1 ? globalMU.replaceAll(parte1[1].substring(3, 4), "_", "") : null,
        numeroDocumento: (parte2?.length ?? 0) > 2 ? global.replaceAll(parte2[2].substring(3, 6), "_", "") : null,
        numeroConta: (parte3?.length ?? 0) > 1 ? global.replaceAll(parte3[1].substring(1, 10), "_", "") : null
        
    }

}